import React from 'react';
import { useLocation } from 'react-router-dom';

function SANSRS_Implementation_Guidelines() {
  const location = useLocation();

  // Extract the page query parameter from the URL (default to page 1 if not present)
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get('page') || 1;

  return (
    <div className="pdf-page">
      <iframe
        src={`/pdf/SANSRS_Implementation_Guidelines_V_2_0.pdf#page=${page}`}
        title="PDF Document"
        width="100%"
        height="600px"
      />
    </div>
  );
}

export default SANSRS_Implementation_Guidelines;
